import script from "./ShuangkeDetailsComponets.vue?vue&type=script&setup=true&lang=js"
export * from "./ShuangkeDetailsComponets.vue?vue&type=script&setup=true&lang=js"

import "./ShuangkeDetailsComponets.vue?vue&type=style&index=0&id=0830220c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0830220c"]])

export default __exports__